import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import styled from 'styled-components';

const PAGE_MAX_WIDTH = '1200px';

export const StyledSection = styled(Flex)`
  padding: ${themeSpace(8)} ${themeSpace(7)};
  justify-content: center;
  flex-direction: column;
  gap: ${themeSpace(9)};
  ${themeMediaQuery('md')} {
    padding: ${themeSpace(8)} ${themeSpace(12)};
  }
  ${themeMediaQuery('lg')} {
    max-width: ${PAGE_MAX_WIDTH};
    padding: ${themeSpace(8)} 0;
  }
`;

export const StyledFeatureContainer = styled(Box)`
  display: grid;
  gap: ${themeSpace(6)};
  ${themeMediaQuery('sm')} {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

export const StyledFeatureWrapper = styled(Flex)`
  flex-direction: column;
  gap: ${themeSpace(6)};
  justify-content: space-between;
  padding: 0 ${themeSpace(3)} ${themeSpace(6)};
  border-bottom: 1px solid ${themeColor('mono3')};
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  border-top: 1px solid ${themeColor('mono3')};
`;

export const StyledGridContainer = styled(Box)`
  display: grid;
  grid-gap: ${themeSpace(6)};
  ${themeMediaQuery('md')} {
    grid-template-columns: 3fr 2fr;
  }
`;

export const StyledCardWrapper = styled(Box)`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-gap: ${themeSpace(6)};
`;
